"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MensagensDoSistema;
(function (MensagensDoSistema) {
    MensagensDoSistema["AzulMU"] = "#0172CB";
    MensagensDoSistema["AzulFillMU400"] = "#69B6DA";
    MensagensDoSistema["AzulFillMU50"] = "#E8F4FA";
    MensagensDoSistema["VerdeMU"] = "#119822";
    MensagensDoSistema["VerdeADMU"] = "#70C17A";
    MensagensDoSistema["VerdeFillMU"] = "#E2F2E5";
    MensagensDoSistema["LaranjaMU"] = "#F4762A";
    MensagensDoSistema["LaranjaADMU"] = "#F8AD7F";
    MensagensDoSistema["LaranjaFillMU"] = "#FDE4D4";
    MensagensDoSistema["AmareloMU"] = "#EFCA08";
    MensagensDoSistema["AmareloADMU"] = "#F6E483";
    MensagensDoSistema["AmareloFillMU"] = "#FDFAE9";
    MensagensDoSistema["VermelhoMU"] = "#D21C1C";
    MensagensDoSistema["VermelhoADMU"] = "#E47777";
    MensagensDoSistema["VermelhoFillMU"] = "#F8DBDB";
})(MensagensDoSistema || (MensagensDoSistema = {}));
exports.default = MensagensDoSistema;
